import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginService } from './shared/services/login.service';
import { Title } from '@angular/platform-browser';
import { Router, NavigationStart } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { ServiceBase } from './shared/services/service-base';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../app-environments/environment';
import { FeatureToggleService } from './shared/services/feature-toggle.service';
import { FeatureToggle } from './shared/data-objects/feature-toggle';
import moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  applicationOfflineWarningMsg: string;
  isApplicationOffline: boolean;
  showApplicationOfflineWarningMessage: string | boolean;
  applicationOfflineMsgText: string;
  validationSummary: string;
  tempReturnUrl: string;
  isRequesting: boolean;
  isPaymentStatusBeingRouted = false;
  //isGuestRoute: boolean = false;

  logoutModalTimer: any;
  showLogoutModal: boolean = false;

  _feature: FeatureToggle;

  get isLogged(): boolean {
    return this.loginService.isUserLoggedIn();
  }

  get isGuestUserLoggedIn(): boolean {
    if (this._feature) {
      return this._feature.DisableGuestUsers ? false : this.loginService.isGuestUserLoggedIn();
    } else {
      return false;
    }
  }

  get isTechCSOUserLoggedIn(): boolean {
    return this.loginService.isTechCSOUserLoggedIn() || this.loginService.isSystemAdminUserLoggedIn();
  }

  get isSystemAdminUserLoggedIn(): boolean {
    return this.loginService.isSystemAdminUserLoggedIn();
  }

  get canSeeMyApplications(): boolean {
    return this.isLogged && !this.isGuestUserLoggedIn;
  }

  get canSeeMyDetails(): boolean {
    return this.isLogged && !this.isGuestUserLoggedIn;
  }

  get canSeeLogin(): boolean {
    //return !this.isLogged && !this.isGuestRoute && !this.isApplicationOffline;
    return (!this.isLogged || this.isGuestUserLoggedIn) && !this.isApplicationOffline;
  }

  get canSeeRegister(): boolean {
    //return !this.isGuestUserLoggedIn && !this.isLogged && !this.isGuestRoute && !this.isApplicationOffline;
    return (!this.isLogged || this.isGuestUserLoggedIn) && !this.isApplicationOffline;
  }

  get canSeeCheckMyApplication(): boolean {
    //return this.isGuestRoute || this.isGuestUserLoggedIn;
    return this.isGuestUserLoggedIn;
  }

  get canSeeApply(): boolean {
    //return this.isGuestRoute || this.isLogged;
    return this.isLogged;
  }

  get canLogout(): boolean {
    return this.isLogged && !this.isGuestUserLoggedIn;
  }

  get isPaymentStatusVisible(): boolean {
    return this.isPaymentStatusBeingRouted;
  }

  constructor(private loginService: LoginService, private titleService: Title, private router: Router,
    private url: LocationStrategy, private featureToggleService: FeatureToggleService) {
    if (url.path().toLowerCase() === '/login') {
      //router.navigate(['/login'], {queryParams: {returnUrl: '/sdai'}});
      router.navigate(['/login']);
      //this.isGuestRoute = false;
      //} else if (url.path() === '/' || url.path().toLowerCase().endsWith('/guest')) {
    } else if (url.path() === '/') {
      //router.navigate(['/guest']);
      router.navigate(['/']);
      //this.isGuestRoute = true;
    }
    this.isPaymentStatusBeingRouted = url.path().length > 0 && url.path().indexOf('paymentStatus') > -1;
    ServiceBase.baseHref = this.url.getBaseHref();
    this.loadSettings();
    this.loginService.initUser();

    const getexpiryModalTime = () => {
      // 10 sec for lower envs
      let timer = 1000 * 10;

      const env = environment.envName;
      if (env === 'prod') {
        // 5 min for prod
        timer = 1000 * 60 * 5;
      }

      return timer;
    };

    this.logoutModalTimer = setInterval(async () => {
      const isUserLoggedIn = this.loginService.isUserLoggedIn();
      if (isUserLoggedIn) {
        const now = moment();
        let expiry: any = this.loginService.getLocalUserSessionExpiry();


        if (expiry) {
          expiry = moment(expiry, 'DD-MM-YYYY, HH:mm:ss');
          const duration = moment.duration(expiry.diff(now));
          const minutes = duration.asMinutes();

          // console.log(`now: ${now}; expiry: ${expiry}`);
          // console.log(`session expiry in ${minutes} minutes`);
          // console.log(`conitinue session: ${this.loginService.getLocalUserSessionContinueState()}`);

          if (minutes <= 0) {
            this.showLogoutModal = false;
            this.loginService.logout((data) => {});
            router.navigate(['/login']);
          }

          if (minutes > 0 && minutes < 30) {
            const continueSessionState = this.loginService.getLocalUserSessionContinueState();

            if (!this.showLogoutModal && [null, undefined, ''].indexOf(continueSessionState) > -1) {
              this.showLogoutModal = true;
            }
          }
        }
      }
    }, getexpiryModalTime());
  }

  async ngOnInit() {
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        switch ((<NavigationStart>event).url) {
          case '/':
            this.setTitle('Welcome to Property Plus Online');
            break;
          case '/sdai':
            this.setTitle('Apply for Sewer Details and Asset Information');
            break;
          case '/boe':
            this.setTitle('Apply for Build Over Easement');
            break;
          case '/pfi':
            this.setTitle('Apply for Pressure and Flow Information');
            break;
          case '/usr':
            this.setTitle('Apply for Urgent sewer repair notice');
            break;
          case '/srp':
            this.setTitle('Single Residential Plumbing Application');
            break;
          case '/chm':
            this.setTitle('Application for the Supply of Potable and Recycled Check Meters');
            break;
          case '/cmp-wf':
            this.setTitle('Application for commercial/multi unit plumbing (with fire service)');
            break;
          case '/cmp-nf':
            this.setTitle('Application for commercial/multi unit plumbing');
            break;
          case '/lnd-w':
            this.setTitle('Application for Development works');
            break;
          case '/lnd-nw':
            this.setTitle('Application for Non-works Development');
            break;
          case '/hyd':
            this.setTitle('Application for Hydrant Permit and Agreement');
            break;
          case '/myApplications':
            this.setTitle('My Application History');
            break;
          case '/paymentLink':
            this.setTitle('Generate Payment Link');
            break;
          case '/allocateApplications':
            this.setTitle('Allocate Applications');
            break;
          case '/login':
            this.setTitle('Login to Property Plus Online');
            break;
          case '/register':
            this.setTitle('Register for Property Plus');
            break;
          case '/myDetails':
            this.setTitle('Update My Details');
            break;
          case '/accDetails':
            this.setTitle('My Account Details');
            break;
          case '/myTeam':
            this.setTitle('Registrations');
            break;
          case '/checkAppStatus':
            this.setTitle('Check My Application Status');
            break;
          case '/myHydrantLogs':
            this.setTitle('Hydrant Logs');
            break;
          case '/myCreateHydrant':
            this.setTitle('Create Hydrant Logs');
            break;
          default:
            break;
        }
      }
    });

    // fetch feature-toggles
    await this.getFeatureToggle();
  }

  ngOnDestroy() {
    console.log(`called ngDestroy of app component`);
    if (this.logoutModalTimer) {
      clearInterval(this.logoutModalTimer);
    }
  }

  extendSession(extend: boolean) {
    this.loginService.setLocalUserSessionContinueState(extend);
    this.showLogoutModal = false;
  }

  loadSettings(): void {
    const me: any = this;
    this.loginService.loadSettings().subscribe((vars: any) => {
      me.applicationOfflineWarningMsg = vars.applicationOfflineWarningMsgText;
      me.isApplicationOffline = vars.isApplicationOffline;
      me.applicationOfflineMsgText = vars.applicationOfflineMsgText;
      me.showApplicationOfflineWarningMessage = vars.showApplicationOfflineWarningMessage;
    }, err => {
      console.log(err);
    }
    );
  }

  navigateToApplication(route: string): void {
    if (!this.loginService.isUserLoggedIn()) {
      //this.tempReturnUrl = '/' + route;
      //this.loginService.guestLogin(this.guestLoginOkCb.bind(this), this.guestLoginErrorCb.bind(this));
      this.router.navigate(['/login']);
    } else {
      this.router.navigate([route]);
    }
  }

  guestLoginOkCb(ok: boolean): void {
    if (typeof (ok) === 'boolean') {
      if (!ok) {
        this.validationSummary = 'Error occurred while logging in guest user.';
      }
    }
    this.router.navigate([this.tempReturnUrl]);
  }

  guestLoginErrorCb(err: HttpErrorResponse): void {
    this.validationSummary = err.error.message;
  }

  private setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public getTitle(): string {
    return this.titleService.getTitle();
  }

  receiveMessage: any = (event: any) => {
    if (!event.origin.startsWith('')) {
      return;
    }

    if (event.data !== 'goToHomePage') {
      return;
    }

    if (!this.isLogged) {
      this.router.navigate(['/login']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  };

  async getFeatureToggle() {
    this._feature = this.featureToggleService.features;
    if (!this._feature) {
      await this.featureToggleService.fetchFeatureToggles();
      this._feature = this.featureToggleService.features;
    }
  }

  get feature() {
    return this._feature;
  }

  get isMyTeamVisible(): boolean {
    return this.loginService.isSystemAdminUserLoggedIn() ||
      this.loginService.isAdminUserLoggedIn() ||
      this.loginService.isTechCSOUserLoggedIn();
  }

  get isTeamMembersVisible(): boolean {
    return this.loginService.isSystemAdminUserLoggedIn() ||
      this.loginService.isAdminUserLoggedIn();
  }

  get getEnvironmentName(): string {
    const env = environment.envName || 'UNKNOWN';
    return (env || '').toUpperCase();

    // if (/(localhost|127\.0\.0\.1)/i.test(window.location.origin)) {
    //   return 'LOCAL';
    // } else if (/pplus-dev-gww(.*?)azurewebsites.net/i.test(window.location.origin)) {
    //   return 'DEV';
    // } else if (/pplus-tst-gww-sit(.*?)azurewebsites.net/i.test(window.location.origin)) {
    //   return 'SIT';
    // } else if (/pplus-tst-gww(.*?)azurewebsites.net/i.test(window.location.origin)) {
    //   return 'TEST';
    // } else if (/pplus-prd-gww(.*?)azurewebsites.net/i.test(window.location.origin) ||
    //   /propertyplus.gww.com.au/i.test(window.location.origin)) {
    //   return 'PROD';
    // } else if (/pplus-dr-gww(.*?)azurewebsites.net/i.test(window.location.origin)) {
    //   return 'DR';
    // } else {
    //   return 'UNKNOWN';
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts